export const fontWeight = {
    fw200   : "200",
    fw300   : "300",
    fw400   : "400",
    fw500   : "500",
    fw600   : "600",
    fw700   : "700",
}